import Validate from "../../services/validate-service/Validate";
import AdviceText from "../advice-text-component/AdviceText";
import InputName from "../inputs/input-name-component/InputName";
import PropTypes from "prop-types";
import React from "react";
import "./main-input-component.css";
import { Col, FormGroup, Row } from "shards-react";

const MainInputComponent = props => {
    let {
        options: { miniApp, isEditScreen, showInputError },
        name,
        advicetext,
        handleInput,
        readOnly
    } = props;

    return (
        <FormGroup>
            <label>{props.inputLabel}</label>
            <AdviceText
                showerror={
                    miniApp[name] &&
                    !Validate.isValidInput("name", miniApp[name])
                }
                text={advicetext}
                color={"#8C0E0E"}
            />
            <Row>
                <Col sm={12} md="6" lg="6">
                    <InputName
                        value={miniApp[name] || ""}
                        readOnly={readOnly}
                        valid={Validate.isValidInput("name", miniApp[name])}
                        invalid={
                            isEditScreen
                                ? !Validate.isValidInput("name", miniApp[name])
                                : (showInputError &&
                                      !Validate.isValidInput(
                                          "name",
                                          miniApp[name]
                                      )) ||
                                  (miniApp[name].length >= 1 &&
                                      !Validate.isValidInput(
                                          "name",
                                          miniApp[name]
                                      ))
                        }
                        onChange={handleInput}
                        placeholder={props.inputPlaceholder}
                    />
                </Col>
                <Col sm={12} md={6} lg={6}>
                    <div className="h-100 w-100 d-flex align-items-center">
                        <p>Nome que irá aparecer na lista de eitri-apps.</p>
                    </div>
                </Col>
            </Row>
        </FormGroup>
    );
};

MainInputComponent.propTypes = {
    options: PropTypes.object,
    isAdmin: PropTypes.bool,
    miniApp: PropTypes.object,
    name: PropTypes.string,
    text: PropTypes.string,
    inputPlaceholder: PropTypes.string,
    inputLabel: PropTypes.string,
    showInputError: PropTypes.bool,
    isEditScreen: PropTypes.bool,
    handleInput: PropTypes.func,
    advicetext: PropTypes.string,
    readOnly: PropTypes.bool
};

export default MainInputComponent;
